const variants = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

export default variants;
